import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface MegaMenuProps {
  children: ReactNode;
  isOpen: boolean;
  onClose: () => void;
  className?: string;
  align?: "left" | "right";
}

export const MegaMenu = ({ children, isOpen, onClose, className, align = "left" }: MegaMenuProps) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Overlay - pointer-events-none damit Navigation weiter funktioniert */}
      <div
        className="fixed inset-0 bg-background/10 backdrop-blur-[2px] z-40 pointer-events-none"
      />
      
      {/* Invisible bridge to prevent gap issues */}
      <div
        className="absolute left-0 right-0 top-full h-2 z-50 pointer-events-auto"
      />
      
      {/* Mega Menu Content */}
      <div
        className={cn(
          "absolute top-full mt-2 z-50 pointer-events-auto",
          align === "right" ? "right-0" : "left-0",
          "max-w-[calc(100vw-2rem)]",
          "bg-card rounded-2xl shadow-2xl border border-border/50",
          "animate-in fade-in slide-in-from-top-2 duration-300",
          className
        )}
      >
        {children}
      </div>
    </>
  );
};
